import React, {useState} from 'react';
import './index.scss'
import arrowUp from '../../../images/travel/red_arrow_up.svg'
import arrowBottom from '../../../images/travel/red_arrow_bottom.svg'
import { strings } from '../../../strings/strings';

interface ICart {
    isMobile: boolean
    selectedPackage: string
    personsCount: number
    cost: number
    total: number
};

const Cart: React.FC<ICart> = ({isMobile, selectedPackage, personsCount, cost, total}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const toggleArrowClick = (event: any) => {
        event.preventDefault()
        event.stopPropagation()
        setIsOpen(!isOpen)
    }

    return (
        <div className={'cart'}>
            <div className={'cart__info'}>
                {!isMobile ? <h3>Вибраний пакет</h3> :
                    <div>
                        <div className={'cart__info_expander'}>
                            <div className={'cart__info_expander_info'}>
                                <h4>Вибрана програма</h4>
                                <p>{selectedPackage}</p>
                            </div>
                            {isOpen ? <img onClick={toggleArrowClick} src={arrowUp} alt=""/> : <img onClick={toggleArrowClick} src={arrowBottom} alt=""/>}
                        </div>
                    </div>
                }
                {(isOpen || !isMobile) ?
                    <>
                        <div className={'cart__info_item mt16'}>
                            <p>Кількість туристів:</p>
                            <span>{`${personsCount}`}</span>
                        </div>
                        <div className={'cart__info_item'}>
                            <p>Вартість пакету:</p>
                            <span>{`${cost} ${strings.currencyUAH}`}</span>
                        </div>
                    </> : <></>}
            </div>
            {(isOpen || !isMobile) ?
                <div className={'cart__overall'}>
                    <p>До сплати:</p>
                    <span>{`${total} ${strings.currencyUAH}`}</span>
                </div> : <></>}

        </div>
    );
};

export default Cart